import { AllStylesLandingPageData } from '../../types';
import * as React from 'react';
import { StyleInfo } from '../../types/all-styles-landing-page';
import {
    LocationsListingMobile,
    Typeahead,
    FeatureFlagContext,
    VENUE_STYLE_AND_WAFFLE_FLAG_MAPPING_DICT,
} from '@weddingspot/ws-core-components';
import cls from 'classnames';
import ContentLoader from 'react-content-loader';

const styles = require('./AllStylesLandingPage.scss');

interface Props {
    data: AllStylesLandingPageData;
}

const Placeholder = () => (
    <ContentLoader height={295} width={220} speed={2} primaryColor='#f3f3f3' secondaryColor='#ecebeb'>
        <rect x='30' y='246' rx='3' ry='3' width='160' height='18' />
        <circle cx='110' cy='133' r='90' />
    </ContentLoader>
);

class AllStylesLandingPage extends React.Component<Props> {
    static contextType = FeatureFlagContext;

    render() {
        const { data } = this.props;

        return (
            <>
                <div className={styles.header}>
                    <div className={styles.splash}></div>
                    <h1>Wedding Venue Styles</h1>
                    <div className={styles.subtitle}>
                        Whatever style of venue you’re looking for, Wedding Spot has you covered.
                        <br />
                        Not sure what you’re after yet? No worries.
                        <br />
                        Have a look around and find the style right for your perfect night.
                    </div>
                    <div className={cls(styles.locations, styles.visibleMobile)}>
                        <LocationsListingMobile />
                    </div>
                    <div className={cls(styles.search, styles.visibleMobile)}>
                        <Typeahead />
                        <div className={styles.searchIconWrapper}>
                            <i className={cls(styles.searchIcon, 'icon-hb-nx-search')} />
                        </div>
                    </div>
                </div>
                <div className={styles.allStylesContainer}>
                    {!data || !data.styles.length ? (
                        <div className={styles.placeholdersContainer}>
                            <Placeholder />
                            <Placeholder />
                            <Placeholder />
                            <Placeholder />
                        </div>
                    ) : (
                        <>
                            {data.styles.map((style: StyleInfo, idx: number) => {
                                if (
                                    VENUE_STYLE_AND_WAFFLE_FLAG_MAPPING_DICT[style.name] == undefined ||
                                    !this.context.flagEnabled(VENUE_STYLE_AND_WAFFLE_FLAG_MAPPING_DICT[style.name])
                                ) {
                                    const imageUrl = require('../../assets/images/all-styles-landing-page/' + style.file_name + '.jpg');
                                    return (
                                        <a key={idx} href={style.url} className={styles.styleContainer}>
                                            <img alt={style.name} src={imageUrl} />
                                            <span>{style.name + ' Weddings'}</span>
                                        </a>
                                    );
                                }
                                return null;
                            })}
                        </>
                    )}
                </div>
            </>
        );
    }
}

export default AllStylesLandingPage;
